<div class="container-fluid">

    <div class="pageheader d-flex align-items-center justify-content-between mb-2">
        <h4 class="d-flex align-items-center mb-1">
            Actions
        </h4>
    </div>

    <!-- Manager / Paralegal TL view with tabs -->
    <span *ngIf="authService.isPortalManager() || authService.isPortalParaLegalTL()">

        <ul class="nav nav-underline nav-fill">
            <li class="nav-item">
                <a class="nav-link"
                    [class.active]="activeTaskTab === 'management'"
                    (click)="setActiveTab('management')">
                    Management Actions
                </a>
            </li>
            <li class="nav-item">
                <a class="nav-link"
                    [class.active]="activeTaskTab === 'paralegal'"
                    (click)="setActiveTab('paralegal')">
                    Paralegal Actions
                </a>
            </li>
            <li class="nav-item" *ngIf="authService.canSeeAdminActionList()">
                <a class="nav-link"
                    [class.active]="activeTaskTab === 'admin'"
                    (click)="setActiveTab('admin')">
                    Admin Actions
                </a>
            </li>
        </ul>

        <app-card>
            <app-task-list *ngIf="activeTaskTab === 'management'"
                userType="management"
                tasksFor="user"
                [showCompleted]="true">
            </app-task-list>
            <app-task-list *ngIf="activeTaskTab === 'paralegal'"
                userType="paralegal"
                tasksFor="user"
                [showCompleted]="true">
            </app-task-list>
            <app-task-list *ngIf="activeTaskTab === 'admin'"
                userType="admin"
                tasksFor="user"
                [showCompleted]="true">
            </app-task-list>
        </app-card>

    </span>

    <!-- Standard user view -->
    <span *ngIf="!authService.isPortalManager() && !authService.isPortalParaLegalTL()">

        <div *ngIf="authService.canSeeParalegalActionList()">
            <app-card title="Actions">
                <app-task-list userType="paralegal" tasksFor="user" [showCompleted]="true">
                </app-task-list>
            </app-card>
        </div>

        <div *ngIf="authService.canSeeAdminActionList()">
            <app-card title="Actions">
                <app-task-list userType="admin" tasksFor="user" [showCompleted]="true">
                </app-task-list>
            </app-card>
        </div>

    </span>

</div>